import React, { useState } from 'react';
import { HelpCircle, ChevronDown, ChevronUp, Sparkles, MapPin, Phone } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { useStore } from '../../context/StoreContext';

const FAQS_DATA = [
  {
    qUrdu: 'ہمالین پنسار سٹور اور دواخانہ طب پاکستانی کے سرپرست کون ہیں؟',
    qEn: 'Who is the practitioner behind Himalayan Pansar Store?',
    aUrdu: 'ہمالین پنسار سٹور اور دواخانہ طب پاکستانی کے بانی و طبی سرپرست حکیم مولانا سید عبدالوہاب شاہ شیرازی (فاضل طب والجراحت FTJ) ہیں۔ ہمارا طریقہ علاج حضرت صابر ملتانیؒ کے وضع کردہ "قانون مفرد اعضاء" (طبِ پاکستانی) پر مبنی ہے۔ اس میں اعضائے رئیسہ (اعصاب، عضلات، غدد) کی تشخیص کر کے تحریک، تسکین و تحلیل کے ذریعے مرض کی جڑ کو ختم کیا جاتا ہے۔',
    aEn: 'The founder and medical director is Hakim Maulana Syed Abdul Wahab Shah Shirazi (Fazil-ut-Tibb wal Jarahat FTJ), specializing in Tibb-e-Pakistani (Qanoon-e-Mufrad Aza).'
  },
  {
    qUrdu: 'کیا پورے پاکستان میں کیش آن ڈلیوری (COD) دستیاب ہے؟',
    qEn: 'Is Cash on Delivery available across Pakistan?',
    aUrdu: 'جی ہاں، الحمدللہ پورے پاکستان کے تمام شہروں، قصبوں اور دیہاتوں میں 2 سے 4 کاروباری دنوں میں بحفاظت پارسل پہنچایا جاتا ہے اور ادائیگی سامان ملنے پر کی جا سکتی ہے۔ 5,000 روپے سے زائد کے تمام آرڈرز پر ڈلیوری بالکل مفت ہے۔',
    aEn: 'Yes, nationwide Cash on Delivery (COD) is available across all cities and towns in Pakistan within 2 to 4 business days. Delivery is completely free on all orders over Rs. 5,000.'
  },
  {
    qUrdu: 'ویب سائٹ پر آن لائن آرڈر کیسے درج کروائیں؟',
    qEn: 'How can I place an order on the website?',
    aUrdu: 'ہماری ویب سائٹ پر ہر دوا کے ساتھ "ابھی خریدیں" یا "ٹوکری میں شامل کریں" کا بٹن موجود ہے۔ مطلوبہ دوا منتخب کرنے کے بعد اپنا نام، پتہ اور فون نمبر درج کر کے کیش آن ڈلیوری (COD) آرڈر باآسانی بک کروا سکتے ہیں۔',
    aEn: 'Every medicine includes a "Buy Now" or "Add to Cart" button. Simply select your required weight/quantity, enter your shipping details, and place your Cash on Delivery order.'
  },
  {
    qUrdu: 'کیا ادویات کے کوئی سائیڈ ایفیکٹس (مضر اثرات) ہیں؟',
    qEn: 'Are there any side effects from these herbal medicines?',
    aUrdu: 'ہماری تمام ادویات 100% خالص قدرتی جڑی بوٹیوں، روغن اور کشیدہ عرقیات پر مشتمل ہیں اور ان میں کوئی بھی مضر صحت کیمیکل شامل نہیں کیا جاتا۔ اگر آپ کی کوئی مخصوص حالت ہو تو ہمارے مطب تشریف لا کر یا فون کال کے ذریعے رہنمائی حاصل کر سکتے ہیں۔',
    aEn: 'All products are 100% natural botanicals free from synthetic chemicals. For specific health conditions, visit our clinic or contact us for guidance.'
  },
  {
    qUrdu: 'قانون مفرد اعضاء (طبِ پاکستانی) اور پرانے یونانی طریقہ کار میں کیا فرق ہے؟',
    qEn: 'What is the difference between Qanoon-e-Mufrad Aza and classical Unani?',
    aUrdu: 'روایتی یونانی میں امراض کی مبہم اور غیر سائنسی اخلاط (خون، بلغم، صفرا، سودا) سے تشخیص کی جاتی تھی، جبکہ طبِ پاکستانی (قانون مفرد اعضاء از صابر ملتانیؒ) ایک سائنسی حقیقت ہے جس میں جسم کے تین بنیادی بافتوں اور اعضاء (دماغ و اعصاب، دل و عضلات، جگر و غدد) کی تحریک، تسکین اور تحلیل کی بنیاد پر بالکل درست اور فوری اثر علاج کیا جاتا ہے۔',
    aEn: 'Classical Unani relies on ancient humoral theories, whereas Tibb-e-Pakistani (Qanoon-e-Mufrad Aza) scientifically diagnoses through the three primary elementary tissues (Nervous, Muscular, Glandular), offering rapid and targeted natural healing.'
  }
];

const FaqSection = ({ onContactClick }) => {
  const { lang } = useLanguage();
  const { settings, cmsContent } = useStore();
  const [openIndex, setOpenIndex] = useState(0);

  const faqsList = (cmsContent?.faqs && cmsContent.faqs.length > 0) ? cmsContent.faqs : FAQS_DATA;

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <section className="py-14 bg-gray-50/70 border-b border-gray-100">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        
        {/* Header */}
        <div className="text-center mb-10 space-y-2">
          <div className="inline-flex items-center gap-1.5 px-3.5 py-1 rounded-full bg-emerald-100 text-emerald-800 text-xs font-bold font-title">
            <HelpCircle className="w-3.5 h-3.5" />
            <span>{lang === 'ur' ? 'عام طبی و خریداری سوالات (FAQs)' : 'Frequently Asked Questions (FAQs)'}</span>
          </div>
          <h2 className="text-2xl sm:text-4xl font-black text-pansar-950 font-title">
            {lang === 'ur' ? 'اکثر پوچھے جانے والے سوالات' : 'Frequently Asked Questions'}
          </h2>
          <p className="text-xs sm:text-sm text-gray-500 font-urdu">
            {lang === 'ur' 
              ? 'دواخانہ طب پاکستانی، آن لائن آرڈر اور طریقہ استعمال سے متعلق اہم معلومات' 
              : 'Helpful guidance on our natural pharmacy, orders, and consultations'}
          </p>
        </div>

        {/* FAQs Accordion */}
        <div className="space-y-3">
          {faqsList.map((faq, idx) => {
            const isOpen = openIndex === idx;
            return (
              <div
                key={idx}
                className="bg-white rounded-2xl border border-gray-200/80 overflow-hidden shadow-sm transition-all"
              >
                <button
                  type="button"
                  onClick={() => toggleFaq(idx)}
                  className="w-full p-4 sm:p-5 text-start flex items-center justify-between gap-4 hover:bg-gray-50/50 transition cursor-pointer"
                >
                  <span className="font-bold text-sm sm:text-base text-gray-900 font-subheading leading-relaxed">
                    {lang === 'ur' ? faq.qUrdu : faq.qEn}
                  </span>
                  <div className={`p-1.5 rounded-full ${isOpen ? 'bg-emerald-100 text-emerald-700' : 'bg-gray-100 text-gray-500'} shrink-0 transition-colors`}>
                    {isOpen ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
                  </div>
                </button>

                {isOpen && (
                  <div className="px-5 pb-5 pt-1 text-xs sm:text-sm text-gray-600 font-urdu leading-relaxed border-t border-gray-100 bg-emerald-50/20 text-start">
                    <p>{lang === 'ur' ? faq.aUrdu : faq.aEn}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* Support & Contact Note */}
        <div className="mt-8 text-center bg-white rounded-2xl p-5 border border-gray-200/80 shadow-sm flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="text-start">
            <h4 className="font-bold text-sm text-gray-900 font-subheading">
              {lang === 'ur' ? 'کوئی اور طبی سوال یا مطب کی لوکیشن درکار ہے؟' : 'Have a question or need clinic directions?'}
            </h4>
            <p className="text-xs text-gray-500 font-urdu">
              {lang === 'ur' 
                ? 'دواخانے کا مکمل پتہ، اوقاتِ کار اور گوگل لوکیشن کے لیے رابطہ صفحہ ملاحظہ فرمائیں یا فون کریں۔'
                : 'Visit our contact page for address details, timings, and Google Maps location.'}
            </p>
          </div>
          <div className="flex items-center gap-2 flex-wrap">
            {onContactClick ? (
              <button
                type="button"
                onClick={onContactClick}
                className="px-4 py-2.5 rounded-xl bg-pansar-900 hover:bg-pansar-800 text-white font-bold text-xs flex items-center gap-1.5 font-title transition shadow cursor-pointer"
              >
                <MapPin className="w-4 h-4 text-amber-400" />
                <span>{lang === 'ur' ? 'دواخانہ ایڈریس و لوکیشن' : 'Clinic Location'}</span>
              </button>
            ) : (
              <a
                href="https://maps.app.goo.gl/pHyFP7WjwTa3hqis6"
                target="_blank"
                rel="noopener noreferrer"
                className="px-4 py-2.5 rounded-xl bg-pansar-900 hover:bg-pansar-800 text-white font-bold text-xs flex items-center gap-1.5 font-title transition shadow"
              >
                <MapPin className="w-4 h-4 text-amber-400" />
                <span>{lang === 'ur' ? 'گوگل میپس لوکیشن' : 'Google Maps'}</span>
              </a>
            )}
            <a
              href={`tel:${settings.phone}`}
              className="px-4 py-2.5 rounded-xl bg-emerald-700 hover:bg-emerald-600 text-white font-bold text-xs flex items-center gap-1.5 font-title transition shadow"
              title={lang === 'ur' ? "فون رابطہ" : "Call us"}
            >
              <Phone className="w-3.5 h-3.5 text-white" />
              <span className="font-sans dir-ltr">{settings.phone}</span>
            </a>
          </div>
        </div>

      </div>
    </section>
  );
};

export default FaqSection;
